/**
 *
 * SurveyTemplate
 *
 */

import React, { Component } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import {
  Button,
  Tooltip,
  Tabs,
  Drawer,
  Menu,
  Dropdown,
  Select,
  Tag,
} from "antd"

import "./index.less"
import { pick, get, concat, split, filter, isEmpty } from "lodash"
import EmptyQuestions from "./EmptyQuestions"
import previewIcon from "../../images/preview-icon.svg"
import threePoints from "../../images/three-points.svg"
import EditDivisionForm from "./drawerDivision"
import Loader from "../Loader"
import SurveyConfig from "../SurveyConfig"

import ModalDelete from "../ModalDelete"
import ModalEditSurvey from "../ModalEditSurvey"
import { UploadOutlined, LeftOutlined } from "@ant-design/icons"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import EditSubdimensionForm from "./drawerSubdimension"
import ModalDeleteAllQuestions from "../ModalDeleteAllQuestions"
import QuestionDrawer from "../QuestionDrawer"
import { validate } from "../../utils/functions"
import SurveyMenu from "../SurveyMenu"
import SurveyQuestions from "../SurveyQuestions"
import ModalDeleteQuestion from "../ModalDeleteQuestion"
import { isModuleBySlug } from "../../utils/storage"
import { SEGMENTS } from "../../utils/constants"
import { buttonAction_btns, PageView } from "../Snowplow/config2"
import DashboardAlert from "../DashboardAlert"

const { TabPane } = Tabs
const { Option } = Select
/* eslint-disable react/prefer-stateless-function */
class SurveyTemplate extends Component {
  state = {
    tabSelected: "questions",
    questionsDrawer: false,
    editDrawer: false,
    dimensionDrawer: false,
    subdimensionDrawer: false,
    modalEditSurvey: false,
    id_survey_type: undefined,
    id_scope_type: undefined,
    modalDeleteSurvey: false,
    modalDeleteAllQuestions: false,
    sendProofModal: false,
    testEmailsArr: [],
    isErrorCreateQuestion: false,
    modalDeleteQuestion: false,
    questionDelete: null,
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.isLoadingDeleteAllQuestions !==
      this.props.isLoadingDeleteAllQuestions &&
      this.props.isLoadingDeleteAllQuestions === false
    ) {
      this.setState({ modalDeleteAllQuestions: false })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.isLoadingDeleteAllQuestions !==
      this.props.isLoadingDeleteAllQuestions &&
      nextProps.isLoadingDeleteAllQuestions === false
    ) {
      this.setState({ modalDeleteAllQuestions: false })
    }
    if (nextProps.isErrorCreateQuestion !== this.props.isErrorCreateQuestion) {
      this.setState({ isErrorCreateQuestion: nextProps.isErrorCreateQuestion })
    }
    if (
      nextProps.isLoadingCreateQuestion !==
      this.props.isLoadingCreateQuestion &&
      nextProps.isLoadingCreateQuestion === false &&
      nextProps.isErrorCreateQuestion === false
    ) {
      this.setState({ questionsDrawer: false })
    }
  }

  refInputEmail = React.createRef()

  changeTab = (key) => {
    this.setState({ tabSelected: key })

    window.location.hash = key
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  menu = () => (
    <Menu>
      <SurveyMenu {...this.props} setStateFrom={this.setStateFrom} />
    </Menu>
  )

  handleDeleteEmailClick = (itemDelete) => {
    this.setState({
      testEmailsArr: filter(
        this.state.testEmailsArr,
        (item) => item !== itemDelete
      ),
    })
  }

  handleEnterPress = (e) => {
    if (e.key === "Enter") {
      this.setState({
        testEmailsArr: concat(
          this.state.testEmailsArr,
          filter(
            split(this.refInputEmail.current.input.value, ","),
            (item) => item
          )
        ),
      })
      this.refInputEmail.current.state.value = ""
    }
  }

  renderQuestionDrawer = () => {
    const { questionsDrawer } = this.state
    const {
      question,
      surveyName,
      isLoadingQuestion,
      isLoadingQuestionTypes,
      questionTypes,
      dimensionsQuestion,
      updateQuestionWatcher,
      createQuestionWatcher,
      isLoadingCreateQuestion,
      configSurvey,
      deleteQuestionWatcher,
    } = this.props
    return (
      <QuestionDrawer
        idSurvey={parseInt(this.props.match.params.id)}
        visibleDrawer={questionsDrawer}
        isCreate={!validate.exist(question.id_question)}
        onClose={() => this.setStateFrom("questionsDrawer", false)}
        isLoading={isLoadingQuestion || isLoadingQuestionTypes}
        questionData={question}
        questionTypes={questionTypes}
        surveyData={surveyName}
        dimensionList={dimensionsQuestion}
        updateQuestionWatcher={updateQuestionWatcher}
        createQuestionWatcher={createQuestionWatcher}
        deleteQuestionWatcher={deleteQuestionWatcher}
        configSurvey={configSurvey}
        isLoadingSave={isLoadingCreateQuestion}
      />
    )
  }

  render() {
    const isSegmentsEnabled = isModuleBySlug(SEGMENTS)
    const segments = []
    const tooltipSegments = []

    let quantityQuestionsEngagement = 0
    if (this.props.engagement.length > 0) {
      quantityQuestionsEngagement = this.props.engagement[0].questions.length
      this.props.engagement[0].subdimensions.forEach((subdimension) => {
        quantityQuestionsEngagement += subdimension.questions.length
      })
    }

    if (this.props.surveyName.id_scope_type === 2) {
      for (let i = 0; i < this.props.surveyName.segments.length; i++) {
        let item = this.props.surveyName.segments[i]
        if (i > 3) {
          tooltipSegments.push(<div>- {item.name}</div>)
        } else {
          segments.push(
            <Tag
              style={{ fontWeight: "400", fontSize: "13px" }}
              key={item.id_segment}>
              {item.name}
            </Tag>
          )
        }
      }

      if (tooltipSegments.length > 0) {
        segments.push(
          <Tooltip title={tooltipSegments} placement="bottom">
            <Tag style={{ fontWeight: "400", fontSize: "13px" }}>
              +{tooltipSegments.length}
            </Tag>{" "}
          </Tooltip>
        )
      }
    }

    return (
      <div className="survey-container">
        {(this.props.questions.questions) && (
          (!this.props.hasLikertQuestions && this.props.questions.questions.length > 0) 
            && (
              <DashboardAlert type="important">
                Este cuestionario <strong>no podrá ser utilizado para agendar una medición</strong> porque <strong> no cuenta con preguntas tipo Likert</strong>.
              </DashboardAlert>
            )
        )}
        <div className="survey-container-margin">
          <div className="survey-container-margin-box">
            <div
              className="btnBack"
              style={{ marginBottom: 16 }}
              onClick={() => this.props.history.push("/models/surveys")}>
              <LeftOutlined />
              Modelos
            </div>
            <div className="survey-container-title">
              {get(this.props.surveyName, "name", "")}{" "}
              <span>
                - {get(this.props.surveyName, "survey_type", "")}{" "}
                {quantityQuestionsEngagement > 0 && (
                  <span
                    style={{
                      marginLeft: "8px",
                      padding: "4px 8px",
                      borderRadius: "3px",
                      background: "rgba(44, 91, 255, 0.1)",
                      color: "#2C5BFF",
                      fontWeight: "600",
                    }}>
                    Engagement
                  </span>
                )}
              </span>
            </div>
            {isSegmentsEnabled && this.props.surveyName.id_scope_type === 2 && (
              <div style={{ marginTop: "10px" }}>
                <span
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#767676",
                  }}>
                  Segmento(s): {segments}
                </span>
              </div>
            )}
          </div>
          <div style={{ position: "relative" }}>
            <Tabs
              animated={false}
              className="tabs"
              activeKey={this.state.tabSelected}
              onChange={this.changeTab}>
              <TabPane tab="Preguntas" key="questions">
                {this.state.tabSelected === "questions" &&
                  // !this.props.isLoadingSurvey ?
                  !get(this.props, "survey", []).length &&
                  !get(this.props.surveyQualitative, "data", []).length &&
                  !get(this.props.surveyEnps, "data", []).length &&
                  !get(this.props.listQuestionMultipleChoice, "data", [])
                    .length ? (
                  <EmptyQuestions
                    toggleDrawer={this.setStateFrom}
                    {...this.props}
                  />
                ) : (
                  <SurveyQuestions
                    {...this.props}
                    setStateFrom={this.setStateFrom}
                    openModalDeleteQuestion={() =>
                      this.setState({ modalDeleteQuestion: true })
                    }
                  />
                )}
              </TabPane>
              {!isEmpty(this.props.questions) && (
                <TabPane
                  // disabled={this.props.isLoadingConfigSurvey}
                  tab="Configuración"
                  key="config">
                  {this.state.tabSelected === "config" && (
                    <SurveyConfig
                      measures={get(this.props.surveyName, "measures", [])}
                      {...pick(this.props, [
                        "uploadBgImageWatcher",
                        "updateConfigSurveyWatcher",
                        "configSurvey",
                        "questions",
                        "uploadBgImage",
                        "isLoadingUploadBgImage",
                        "uploadLogoWatcher",
                        "uploadLogo",
                        "isLoadingUploadLogo",
                      ])}
                    />
                  )}
                </TabPane>
              )}
            </Tabs>

            {!get(this.props, "survey", []).length &&
              !get(this.props.surveyQualitative, "data", []).length &&
              !get(this.props.surveyEnps, "data", []).length &&
              !get(this.props.listQuestionMultipleChoice, "data", []).length ? (
              <div className="survey-buttons">
                <Button
                  type="primary"
                  className="QuestionDrawer__button--create"
                  onClick={() => {
                    woopraTrack("Nueva Pregunta Cuestionario")
                    this.props.getQuestionTypesWatcher(
                      this.props.match.params.id
                    )
                    this.props.getQuestionSuccess({})
                    this.setStateFrom("questionsDrawer", true)
                    window.Intercom('update', { hide_default_launcher: true});
                    Intercom("close")
                  }}>
                  + Nueva pregunta
                </Button>
                <Tooltip placement="topRight" title="Importar preguntas">
                  <Button
                    style={{
                      display: "flex",
                      marginLeft: 5,
                    }}
                    className="importButton"
                    size="default"
                    icon={<UploadOutlined />}
                    onClick={() => {
                      this.props.url()
                      PageView(
                        "Vista interna de modelo - Visualizar página de importación de cuestionario",
                        'id_survey',
                        this.props.match.params.id
                      )
                    }}
                  />
                </Tooltip>
              </div>
            ) : (
              <div className="survey-buttons">
                <Button
                  type="primary"
                  className="QuestionDrawer__button--create"
                  onClick={() => {
                    woopraTrack("Nueva Pregunta Cuestionario")
                    this.props.getQuestionTypesWatcher(
                      this.props.match.params.id
                    )
                    this.props.getQuestionSuccess({})
                    this.setStateFrom("questionsDrawer", true)
                    window.Intercom('update', { hide_default_launcher: true});
                    Intercom("close")
                  }}>
                  + Nueva pregunta
                </Button>
                <Tooltip placement="top" title="Previsualizar">
                  <Button
                    onClick={() => {
                      buttonAction_btns("Previsualizar modelo de cuestionario")
                      window.open(
                        `${process.env.QUESTIONNAIRE_URL}surveys/answers/${this.props.match.params.id}`,
                        "_blank"
                      )
                    }}
                    style={{ marginLeft: 8 }}
                    className="importButton"
                    size="default">
                    <img src={previewIcon} />
                  </Button>
                </Tooltip>
                <Dropdown overlay={this.menu()}>
                  <img
                    src={threePoints}
                    style={{ marginLeft: 8, cursor: "pointer" }}
                  />
                </Dropdown>
              </div>
            )}
          </div>
        </div>
        {this.renderQuestionDrawer()}
        <Drawer
          title="Editar dimensión"
          placement="right"
          closable
          width="525px"
          onClose={() => {
            this.setStateFrom("dimensionDrawer", false)
            Intercom('update', { hide_default_launcher: false });
          }}
          visible={this.state.dimensionDrawer}
          bodyStyle={{ padding: 0 }}>
          {this.state.dimensionDrawer && !this.props.isLoadingDimension ? (
            <EditDivisionForm
              toggleDrawer={this.setStateFrom}
              {...pick(this.props, ["dimension", "updateDimensionWatcher"])}
            />
          ) : (
            <Loader />
          )}
        </Drawer>
        <Drawer
          title="Editar Subdimensión"
          placement="right"
          closable
          width="525px"
          onClose={() => {
            this.setStateFrom("subdimensionDrawer", false)
            Intercom('update', { hide_default_launcher: false });
          }}
          
          visible={this.state.subdimensionDrawer}
          bodyStyle={{ padding: 0 }}>
          {this.state.subdimensionDrawer && !this.props.isLoadingDimension ? (
            <EditSubdimensionForm
              toggleDrawer={this.setStateFrom}
              {...pick(this.props, [
                "dimension",
                "updateDimensionWatcher",
                "dimensionsQuestion",
              ])}
            />
          ) : (
            <Loader />
          )}
        </Drawer>

        <ModalEditSurvey
          {...this.props}
          visible={this.state.modalEditSurvey}
          setStateFrom={this.setStateFrom}
          updateSurveyWatcher={this.props.updateSurveyWatcher}
          idSurvey={this.props.match.params.id}
          surveyName={this.props.surveyName}
        />

        <ModalDeleteAllQuestions
          deleteItem={this.props.deleteAllQuestionsWatcher}
          visible={this.state.modalDeleteAllQuestions}
          setStateFrom={this.setStateFrom}
          itemId={this.props.surveyName.id_survey}
          measures={this.props.configSurvey.measures_count}
          forceReload={(status) => this.props.forceReload(status)}
        />

        <ModalDelete
          deleteItem={this.props.deleteSurveyWatcher}
          visible={this.state.modalDeleteSurvey}
          setStateFrom={this.setStateFrom}
          itemId={this.props.surveyName.id_survey}
          measures={this.props.configSurvey.measures_count}
        />

        <ModalDeleteQuestion
          modalOpen={this.state.modalDeleteQuestion}
          question={this.state.questionDelete}
          survey={this.props.match.params}
          deleteQuestion={(data) => {
            this.props.deleteQuestionWatcher(data)
            this.setState({ modalDeleteQuestion: false })
          }}
          cancelDeleteQuestion={() =>
            this.setState({ modalDeleteQuestion: false })
          }
          configSurvey={this.props.configSurvey}
        />
      </div>
    )
  }
}

SurveyTemplate.propTypes = {}

export default SurveyTemplate
